import { useEffect, useState } from "react";
import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import axios from "axios";
import SEO from "@/components/SEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("hm-admin-token");
export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export default function AdminLayout() {
  const [state, setState] = useState("checking");
  const navigate = useNavigate();

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setState("denied");
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: authHeaders() })
      .then(() => setState("ok"))
      .catch(() => {
        localStorage.removeItem("hm-admin-token");
        setState("denied");
      });
  }, []);

  if (state === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-base">
        <p className="kicker">Se verifică sesiunea...</p>
      </div>
    );
  }
  if (state === "denied") return <Navigate to="/admin/login" replace />;

  const logout = () => {
    localStorage.removeItem("hm-admin-token");
    navigate("/admin/login");
  };

  const tabCls = ({ isActive }) =>
    `px-4 py-2 text-xs font-semibold uppercase tracking-widest transition-colors ${
      isActive ? "bg-ink text-base" : "text-ink/60 hover:text-ink"
    }`;

  return (
    <div className="min-h-screen bg-base" data-testid="admin-layout">
      <SEO title="Administrare | HEAVY METAL" description="Panou de administrare HEAVY METAL." noindex />
      <header className="sticky top-0 z-40 border-b border-ink/10 bg-base/85 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-5">
            <img src="/logo-mark.png" alt="HEAVY METAL" className="h-10 w-auto" />
            <span className="kicker">Admin</span>
          </div>
          <nav className="flex items-center gap-1" data-testid="admin-nav">
            <NavLink to="/admin/lead-uri" className={tabCls} data-testid="admin-nav-leads">
              Lead-uri
            </NavLink>
            <NavLink to="/admin/portofoliu" className={tabCls} data-testid="admin-nav-portfolio">
              Portofoliu
            </NavLink>
            <button
              onClick={logout}
              data-testid="admin-logout"
              className="ml-3 flex items-center gap-2 px-4 py-2 text-xs font-semibold uppercase tracking-widest text-ink/60 transition-colors hover:text-ink"
            >
              <LogOut className="h-3.5 w-3.5" /> Ieșire
            </button>
          </nav>
        </div>
      </header>
      <div className="scaffold-watermark" aria-hidden />
      <main className="relative z-10 mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <Outlet />
      </main>
    </div>
  );
}
